import React, { useEffect, useState, useContext, useRef } from 'react';
import { connect } from "react-redux"
import {Icon, Statistic, Grid, Transition, Segment, Button, Divider, Label, Modal, Input} from 'semantic-ui-react';

import OpinionForm from '../../components/Forms/OpinionForm';
import CommentForm from '../../components/Forms/CommentForm';
import BookingsCardList from '../../components/Bookings/BookingsCard/BookingsCardList';
import GlobalContext from '../../contexts/GlobalContext';
import API, { ResponseManagement, ErrorManagement } from '../../API';
import Utility, { errorsCodes } from '../../Utility';
import MomentCustomer from '../../components/MomentCustomer/MomentCustomer';
import './BookingsDetails.css';
import PanierContext from '../../contexts/PanierContext';
import ModalContext from '../../contexts/ModalContext';
import AmountProvider from '../../components/Provider/AmountProvider';
import NotifContext from '../../contexts/NotifContext';
import { DELETE_NOTIF } from '../../contexts/NotifType';
import Auth from '../../Auth';
import { toast } from 'react-toastify';
import {config} from "../../Config";
import BankCardsList from "../../components/BankCardsList/BankCardsList";
import Loader from '../../components/Basics/Loader'
import { createBookingsData, totalBookingFolderPrice } from '../../store/booking'

//import useBankForm from "../../hooks/useBankForm";
//import useRouter from "../../hooks/useRouter";
import ModalTransition from "../../components/ModalTransition/ModalTransition";
import {  useParams, useNavigate } from 'react-router-dom';
import {displayToastErrorFromResponse} from "@components/TradsErrorPages/ErrorUtil";

const mapProps = (state) => ({
  bankCards: state.bank.cards,
  isActivatedBank: state.bank.isActivated,
  isFirstCard: state.bank.isFirstCard,
  bookings: state.booking.bookings,
  bookingFolder: state.booking.bookingFolder,
  bookingCancel: state.booking.bookingCancel,
  rating: state.rating.rating,
  totalBookingFolderPrice: totalBookingFolderPrice(state),
  isOpenInvoiceModal: state.modal.handleBookingFolderInvoices
})

const mapDispatch = (dispatch) => ({
  loadBankCards: dispatch.bank.load,
  addBankCard: dispatch.bank.addCard,
  setStateProperties: dispatch.bank.setStateProperties,
  handleRedirectType: dispatch.authentication.handleRedirectType,
  loadBookings: dispatch.booking.load,
  loadRatings: dispatch.rating.load,
  loadSupplements: dispatch.supplement.load,
  loadRateplans: dispatch.rateplan.load,
  loadAccommodations: dispatch.accommodation.loaded,
  handleInvoiceModal: dispatch.modal.handleModal
})

const BookingDetails = ({
  loadBookings,
  bookings,
  bookingFolder,
  bookingCancel,
  loadBankCards,
  isFirstCard,
  addBankCard,
  rating,
  loadRatings,
  loadSupplements,
  loadRateplans,
  loadAccommodations,
  totalBookingFolderPrice,
  ...props
}) => {
  // Refs
  const divBankCardsList = useRef(null);
  const messageDivRef = useRef(null);

  // Contexts
  const [globalContext] = useContext(GlobalContext);
  const [panierState] = useContext(PanierContext);
  const [notifState, notifDispatch] = useContext(NotifContext);
  const { modalIsOpen, setModalIsOpen } = useContext(ModalContext);
  const { bookingFolderId, setBookingFolderId } = useContext(ModalContext);

  // States
  const [loaderActive, setLoaderActive] = useState(true);
  const [reloadDataState, setReloadDataState] = useState(false);
  const [visibleState, setVisibleState] = useState(false);
  const [bookingBankCardsListState, setBookingBankCardsListState] = useState(
    []
  );
  const [messagesState, setMessagesState] = useState([]);
  const [invoices, setInvoicesState] = useState([]);
  //const [isLoadingState, setIsLoadingState] = useState(true);
  const [selectedInvoice, setSelectedInvoiceState] = useState({})
  const [inputMailValue, setInputMailValue] = useState(globalContext.user.mail);
  const [loaderMailButton, setLoaderMailButton] = useState(false)
  const [showMultiEtabState, setShowMultiEtabState] = useState(false);  
  const [showFormOpinionState, setShowFormOpinionState] = useState(false);
  const [pdfInvoicesBase64, setPdfInvoicesBase64] = useState("");


  // Router
  //const router = useRouter();
  let { token, lang, id } = useParams();
  let navigate = useNavigate();

  const baseUrl = config.url.URL_MB + config.url.BASENAME + "/";
  // const baseUrl = config.url.URL;

  //bookingFolder.state === "passed"

  var activeDownloadInvoice = false;
  var sizeCol = 4;
  if (
    globalContext.displayControl.show_invoice &&
    invoices.length > 0 &&
    Auth.isAuthenticatedViaPassword() === true
  ) {
    activeDownloadInvoice = true;
    sizeCol = 3;
  }
  //

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if ( globalContext.displayControl.OpinionFormRating && bookingFolder.state === "passed" ) {
      setShowFormOpinionState(true)
    }
  }, [bookingFolder]);

  /*useEffect(() => {
    // exemple load form redux
    loadBankCards({
      bookingFolderId: props.match.params.id,
      active: "1",
      bankModuleId: globalContext.establishment.bankModuleInfos.bankModuleId,
      virtualCard: false
    })
  }, [])

  //fermeture de la modale au step 1 si 1ere carte
  useEffect(() => {
    if (isFirstCard) {
      setModalIsOpen(false);
    }
  }, [isFirstCard])

  const onAddBankCardSubmit = () => {
    const newBankCardEl = document.getElementById('insertedCard');
    const newBankCard = JSON.parse(newBankCardEl.value);
    addBankCard(newBankCard);

    const addBankCardFormContainerEl = document.getElementById('bank_card_form');
    addBankCardFormContainerEl.style.display = 'block';

    // success message placé ici car onAddBankCardSubmit = fonction callback success du hook useBankForm
    toast.success(globalContext.translations.successBankCardAdd);
  }

  useBankForm('#modalAddBankCardContainer', '#bankFormInnerContainer', config.url.URL_MB, onAddBankCardSubmit, {
    establishmentId: globalContext.establishment.id,
    organizationId: globalContext.establishment.organizationId,
    bookingFolderId: props.match.params.id,
    userId: 0,
    paymentModule: globalContext.establishment.bankModuleInfos.bankModuleCode, // bizarre il reconait pas
    action: "tokenStorage",
    email: globalContext.user.mail,
  }, props.isActivatedBank);*/

  useEffect(() => {
    if ( globalContext.espaceClientByOrga && Object.keys(globalContext.establishmentCollection).length > 0 ) {
      setShowMultiEtabState(true)
    }
  }, [globalContext.establishmentCollection])

  useEffect(() => {
    if (props.location.state && props.location.state.messageScroll === true) {
      let dataToSend = new URLSearchParams({
        bookingFolderId: props.location.state.folderId,
        author: "hotel",
      });

      API.post(Utility.getUrlAjax() + "/isReadMessage", dataToSend)
        .then((response) => {
          ResponseManagement(
            response,
            () => {
              if (response.data.data.success === true) {
                notifDispatch({
                  type: DELETE_NOTIF,
                  payload: props.location.state.folderId,
                });
              }
            },
            () => {}
          );
        })
        .catch((error) => {
          ErrorManagement(error, () => {});
        });
    }
  }, [props.location.state]);

  useEffect(() => {
    if (id !== undefined) {
      // setBookingFindState(true);
      API.get(
        Utility.getUrlAjax() +
          `/bookingFolderInformations-${id}`
      )
        .then((response) => {
          ResponseManagement(
            response,
            () => {
              // console.log('response.data.data', response.data.data)
              loadRatings(response.data.data.rating);
              loadBookings({
                bookings: createBookingsData(response.data.data),
                bookingFolder: response.data.data.bookingFolder,
                bookingCancel: response.data.data.bookingCancel,
              });
              loadSupplements({
                extrasList: response.data.data.extras,
                optionsList: response.data.data.options,
                extraStock: response.data.data?.extraStock ?? {},
              });
              loadRateplans({
                rateplansList: response.data.data.rateplans, // array
                rateplanServicesList: response.data.data.rateplanServices,
                cancellationConditionsList:
                  response.data.data.cancellationConditions,
              });
              loadAccommodations({
                accommodationServicesList:
                  response.data.data.accommodationServices, // array
              });

              setMessagesState(response.data.data.messages);

              setInvoicesState(response.data.data.invoices);

              /*const hash = props.history.location.hash;
              const subHash = document.getElementById(hash.substr(1));
              if (hash && subHash) {
                // Check if there is a hash and if an element with that id exists
                setTimeout(
                  () =>
                    subHash.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                    }),
                  500
                );
              }*/

              if (
                props.location.state &&
                props.location.state.messageScroll === true
              ) {
                window.scrollTo(0, document.body.scrollHeight);
              }

              //setIsLoadingState(false);
              //setVisibleState(true);
              setTimeout(() => {
                setLoaderActive(false);
                //setIsLoadingState(false);
                setVisibleState(true);
              }, 500);
            },
            () => {
              if (response?.data?.message) {
                toast.error(globalContext.translations[response.data.message]);
              } else {
                displayToastErrorFromResponse(response);
              }
              setTimeout(() => {
                if (errorsCodes.includes(response.data.message)) {
                  navigate(
                    `${token}/${lang}/login`
                  );
                } else {
                  navigate("/");
                }
              }, 5500);
              //Auth.logout();
            }
          );
        })
        .catch((error) => {
          ErrorManagement(error, () => {
            setTimeout(() => {
              //setIsLoadingState(false);
              setVisibleState(true);
              setLoaderActive(false);
            }, 5500);
          });
        });
    } else {
      //setIsLoadingState(false);
    }
  }, [
    localStorage.getItem("lang"),
    id,
    panierState.orderPay,
    reloadDataState,
  ]);

  const handleDownloadInvoices = (invoice) => {
    let dataToSend = new URLSearchParams({
      establishmentId: bookingFolder.establishmentId,
      bookingFolderId: invoice.bookingFolderId,
      invoices: JSON.stringify(invoice)
    });

    API.post(Utility.getUrlAjax() + '/base64InvoicesPdf', dataToSend)
      .then(response => {
        ResponseManagement(response,
          () => {
            setPdfInvoicesBase64(response.data.data);
            props.handleInvoiceModal({handleBookingFolderInvoices: true});
          },
          () => {
            toast.error(globalContext.translations[response.data.message])
          }
        );
      })
      .catch(error => {
        console.error("error",error)
        ErrorManagement(error, () => { });
      })
      .finally(() => {
        setLoaderMailButton(false);
      })
  }


  const handleSendInvoice = (bookingForlderEstablishmentId, folderInvoices) => {
    let dataToSend = new URLSearchParams({
      establishmentId: bookingForlderEstablishmentId,
      bookingFolderId: folderInvoices.bookingFolderId,
      email: inputMailValue,
      invoices: JSON.stringify(selectedInvoice)
    });

    setLoaderMailButton(true);

    API.post(Utility.getUrlAjax() + '/sendMailBookingFolderInvoices', dataToSend)
      .then(response => {
        ResponseManagement(response,
          () => {
            if (response.data.success) {
              toast.success(globalContext.translations[response.data.message]);
              props.handleInvoiceModal({handleBookingFolderInvoices: false})
              setSelectedInvoiceState({});
            }
          },
          () => {
            toast.error(globalContext.translations[response.data.message])
          }
        );
      })
      .catch(error => {
        console.error("error",error)
        ErrorManagement(error, () => { });
      })
      .finally(() => {
        setLoaderMailButton(false);
      })
  }

  const handleInputMailValue = (e, data) => {
    if (data?.value) {
      setInputMailValue(data.value)
    }
  }

  return (
    <div className="booking-detail-main">
      <Loader active={loaderActive} />
      {bookingFolder ? (
        <div>
          <Transition visible={visibleState} animation="" duration={500}>
            <div id="bookings-grid">
              {/* title-mb */}
              <div
                style={{ alignItems: "center" }}
                className="mt-5 d-flex justify-content-between"
              >
                <div className="mr-1">
                  {Auth.isAuthenticatedViaPassword() === true && (
                    <Button onClick={() => navigate(-1)} icon>
                      <Icon name="angle left" />
                    </Button>
                  )}
                </div>
                <div style={{ width: "95%" }} className="text-center">
                  <h2 style={{ fontSize: "1.2em" }}>
                    {globalContext.translations.stayFrom}
                    &nbsp;
                    <MomentCustomer>{bookingFolder.arrivalDate}</MomentCustomer>
                    &nbsp;{globalContext.translations.modalCheckInTo}
                    &nbsp;
                    <MomentCustomer>
                      {bookingFolder.departureDate}
                    </MomentCustomer>
                  </h2>
                  {/* si multi etab affiche, nom hotel et adresse */}
                  { showMultiEtabState && (
                    <p><b>{globalContext.establishmentCollection[bookingFolder.establishmentId]?.name}</b>
                    { globalContext.establishmentCollection[bookingFolder.establishmentId]?.city ?
                      <span>&nbsp;<Icon color="blue"
                      name="map marker alternate" /> {globalContext.establishmentCollection[bookingFolder.establishmentId]?.city} - {globalContext.establishmentCollection[bookingFolder.establishmentId]?.zipCode}
                      </span>
                      : ""
                    }
                    </p>
                  ) }
                </div>
              </div>

              {/****************** ENTETE BOOKING DETAIL *********************/}
              <Grid
                columns="equal"
                className="mb-2 mt-4"
                style={{ height: "100%" }}
              >
                <Grid.Row className="py-0">
                  <Grid.Column computer={16}>
                    <Segment>
                      <Grid
                        textAlign="center"
                        verticalAlign="middle"
                        columns="equal"
                        style={{ height: "100%" }}
                      >
                        <Grid.Row>
                          <Grid.Column
                            className="borderRight borderBottom"
                            mobile={8}
                            computer={sizeCol}
                          >
                            <Statistic size="mini">
                              <Statistic.Value>
                                <Icon
                                  className="mr-2"
                                  color="blue"
                                  name="calendar check outline"
                                />
                                <span style={{ fontSize: "0.9rem" }}>
                                  <MomentCustomer format="DD MMM YYYY">
                                    {bookingFolder.creationDate}
                                  </MomentCustomer>
                                </span>
                              </Statistic.Value>
                              <Statistic.Label className="labelResumeFolder">
                                {Utility.upperCase(
                                  globalContext.translations.bookingDate
                                )}
                              </Statistic.Label>
                            </Statistic>
                          </Grid.Column>
                          <Grid.Column
                            className="borderRight borderBottom"
                            mobile={8}
                            computer={sizeCol}
                          >
                            <Statistic size="mini">
                              <Statistic.Value>
                                <Icon
                                  className="mr-2"
                                  color="blue"
                                  name="male"
                                />
                                <span>{bookingFolder.paxTotal}</span>
                              </Statistic.Value>
                              <Statistic.Label className="labelResumeFolder">
                                {Utility.upperCase(
                                  globalContext.translations.people
                                )}
                              </Statistic.Label>
                            </Statistic>
                          </Grid.Column>
                          <Grid.Column
                            className={
                              activeDownloadInvoice
                                ? "borderRight borderBottom"
                                : "borderRight"
                            }
                            mobile={8}
                            computer={sizeCol}
                          >
                            <Statistic size="mini">
                              <Statistic.Value>
                                <Icon
                                  className="mr-2"
                                  color="blue"
                                  name="hotel"
                                />
                                <span>{bookingFolder.roomTotal}</span>
                              </Statistic.Value>
                              <Statistic.Label className="labelResumeFolder">
                                {Utility.upperCase(
                                  globalContext.translations[globalContext.affMotChambre]
                                )}
                              </Statistic.Label>
                            </Statistic>
                          </Grid.Column>

                          {/* FACTURES */}
                          {activeDownloadInvoice && (
                            <Grid.Column
                              className="borderRight borderBottom"
                              mobile={8}
                              computer={sizeCol}
                            >
                              <Statistic size="mini">
                                <Statistic.Value>
                                  <Icon
                                    className="mr-2"
                                    color="blue"
                                    name="file pdf outline"
                                  />
                                  <span>{invoices.length}</span>
                                </Statistic.Value>
                                <Statistic.Label className="labelResumeFolder">
                                  {invoices.length == 1
                                    ? Utility.upperCase(
                                        globalContext.translations.showInvoice
                                      )
                                    : Utility.upperCase(
                                        globalContext.translations.showInvoices
                                      )}
                                </Statistic.Label>
                              </Statistic>
                            </Grid.Column>
                          )}

                          <Grid.Column
                            mobile={activeDownloadInvoice ? 16 : 8}
                            computer={3}
                          >
                            <Statistic size="mini">
                              <Statistic.Value>
                                <span className="font-weight-bold">
                                {
                                  // total dossier
                                  bookingFolder?.noteSecondaire ?
                                  <AmountProvider amount={bookingFolder.totalExtraPresta} currency={bookingFolder.currency} />
                                  :
                                  <AmountProvider amount={bookingFolder.servicesTotalAmount} currency={bookingFolder.currency} />
                                }
                                  
                                </span>
                              </Statistic.Value>
                              <Statistic.Label className="labelResumeFolder">
                                {Utility.upperCase(
                                  globalContext.translations.bookingTotalAmount
                                )}
                              </Statistic.Label>
                            </Statistic>
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {/****************** BLOC FACTURE *********************/}
              {activeDownloadInvoice && (
                <Grid
                  className="m-0 mb-2"
                  columns="equal"
                  style={{ height: "100%" }}
                >
                  <Grid.Row centered className="py-0">
                    <Grid.Column
                      mobile={16}
                      computer={16}
                      className="px-0 text-center"
                    >
                      <Segment>
                        {/* Titre */}
                        <div>
                          <h4 className="text-center mb-2">
                            {globalContext.translations.donwloadInvoice}
                          </h4>
                          <div className="ui divider"></div>
                        </div>
                        {/* Factures */}
                        <Grid
                          id="boxListeFacture"
                          className="m-0 mb-2"
                          columns="equal"
                          style={{ height: "100%" }}
                        >
                          {invoices.map((invoice, index) => {
                            return (
                              <Grid.Row
                                centered
                                verticalAlign="middle"
                                className="py-0 mb-2 pb-2 borderBottom"
                                key={invoice.id}
                              >
                                <Grid.Column
                                  mobile={16}
                                  computer={2}
                                  className="px-0 text-center"
                                >
                                  <Label
                                    as="span"
                                    className="mr-4"
                                    content={
                                      <MomentCustomer format="DD MMM YYYY">
                                        {invoice.date}
                                      </MomentCustomer>
                                    }
                                  />
                                </Grid.Column>
                                <Grid.Column
                                  mobile={16}
                                  computer={10}
                                  className="px-0 text-center"
                                >
                                  <span className="mr-4">
                                    {invoice.downPayment == "oui"
                                      ? globalContext.translations
                                          .invoiceAcompteNum
                                      : globalContext.translations
                                          .invoiceNum}{" "}
                                    : {invoice.number}
                                  </span>
                                </Grid.Column>
                                <Grid.Column
                                  mobile={16}
                                  computer={4}
                                  className="px-0 colAlignLeftMcenter"
                                >
                                  <Button
                                    className="ui primary basic mini button"
                                    icon
                                    primary
                                    basic
                                    size="mini"
                                    onClick={() => {
                                      handleDownloadInvoices(invoice)
                                    }}
                                  >
                                    Voir la facture
                                  </Button>
                                  <Button
                                    className="send_mail_invoices_btn"
                                    icon
                                    primary
                                    basic
                                    size="mini"
                                    onClick={() => {
                                      setSelectedInvoiceState(invoice)
                                      props.handleInvoiceModal({handleBookingFolderInvoices: true})
                                    }}
                                  >
                                    <Icon name="paper plane" />
                                  </Button>
                                  <span className="ml-4">
                                    <AmountProvider
                                      amount={invoice.amount}
                                      currency={bookingFolder.currency}
                                    />
                                  </span>
                                </Grid.Column>
                              </Grid.Row>
                            );
                          })}
                        </Grid>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )}
              {/****************** BLOC RETOUR CLIENT *********************/}
              {showFormOpinionState && (
                <Grid
                  className="m-0"
                  columns="equal"
                  style={{ height: "100%" }}
                >
                  <Grid.Row centered className="py-0">
                    <Grid.Column mobile={16} computer={16} className="px-0">
                      <Segment>
                        <OpinionForm
                          rating={rating}
                          bookingFolder={bookingFolder}
                        />
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              )}
              {/*********************  Liste des réservations => BookingsCard ***************/}
              <BookingsCardList />
              <div ref={messageDivRef}>
                {/*props.isActivatedBank &&
                  <Segment id="bankCards-segment">
                    <div>
                      <h3 className="text-center mb-2">{globalContext.translations.handleBankCard}</h3>
                      <Divider/>
                    </div>
                    <Grid className="m-0" divided columns="equal" style={{height: '100%'}}>
                      <Grid.Row centered className="py-0">
                        <Grid.Column mobile={16} computer={8}>
                          Listing des utilisations des CB
                        </Grid.Column>
                        <Grid.Column mobile={16} computer={8}>
                          <div className="scrollDivContainer">
                            <div id="scrollDiv" ref={divBankCardsList} style={{
                              height: 350,
                              paddingRight: '2%',
                              overflow: 'auto',
                              background: 'white',
                              borderRadius: 3
                            }}>
                              <BankCardsList 
                                isForBankCardsHandler={true} 
                                bankCardsList={bookingBankCardsListState}
                                setBankCardsList={setBookingBankCardsListState}
                              />
                            </div>
                          </div>
                          <div className="add-bankCard-container custom-align-right">
                            <Button
                              id="add-bankCard-button"
                              size="mini"
                              onClick={() => {props.handleRedirectType(() => {
                                setModalIsOpen(!modalIsOpen)
                                setBookingFolderId(bookingFolder.id);
                              })}}
                              positive
                              icon="credit card"
                              labelPosition="left"
                              content={globalContext.translations.preCheckInAdd}
                            />
                          </div>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Segment>
                */}
                {
                  // SI MESSAGERIE ACTIVEE
                  globalContext.displayControl.messaging && (
                    <Segment id="messages-segment">
                      <Grid
                        className="m-0"
                        columns="equal"
                        style={{ height: "100%" }}
                      >
                        <Grid.Row centered className="py-0">
                          <Grid.Column
                            mobile={16}
                            computer={16}
                            className="px-0"
                          >
                            <CommentForm
                              folderId={bookingFolder.id}
                              messages={messagesState}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                    </Segment>
                  )
                }
              </div>
            </div>
          </Transition>
        </div>
      ) : (
        <div className="p-5">
          <h3 style={{ textAlign: "center" }}>Not authorized</h3>
        </div>
      )}
      {/*
        isLoadingState
        ? <BookingDetailsLoader />
        : getContent()
      */}

      <ModalTransition
        open={props.isOpenInvoiceModal}
        handleClose={() => {
          props.handleInvoiceModal({handleBookingFolderInvoices: false})
          setPdfInvoicesBase64("");
          setSelectedInvoiceState({});
        }}
        closeOnDimmerClick={false}
        size={pdfInvoicesBase64.length > 0 ? "fullscreen" : "tiny"}
        header={globalContext.translations.handleInvoices}
        isForIframe={pdfInvoicesBase64.length > 0}
        style={{height: pdfInvoicesBase64.length > 0 ? "94%" : ""}}
        content={
          <>
            { pdfInvoicesBase64.length > 0 ?
              /*<iframe
                style={{
                  width: "100%",
                  height: "100%",
                  borderStyle: "none"
                }}

                className="iframe_pdf"
                src={`data:application/pdf;base64,${
                  pdfInvoicesBase64
                }`}
              />*/
              <object type="application/pdf"
                  data={`data:application/pdf;base64,${
                    pdfInvoicesBase64
                  }`}
                  width="100%"
                  height="100%">
              </object>
              :
              Object.keys(selectedInvoice).length > 0 && pdfInvoicesBase64.length === 0 ?
                <Modal.Content>
                  <div className="modal_invoices_content_row" >
              
                    <span style={{marginRight: '10px'}}>{globalContext.translations.sendMailSingleInvoice}</span>
                    <Input
                      className="modal_invoices_input_mail"
                      size="mini"
                      onChange={handleInputMailValue}
                      defaultValue={inputMailValue}
                    />

                    <Button
                      icon
                      disabled={loaderMailButton}
                      loading={loaderMailButton}
                      primary
                      basic
                      size="mini"
                      onClick={() => handleSendInvoice(bookingFolder.establishmentId, selectedInvoice)}
                    >
                      <Icon name="paper plane"/>
                    </Button>
                  </div>
                </Modal.Content>
                :
                ''
            }
          </>
        }
      />

    </div>
  );
}

export default connect(mapProps, mapDispatch)(BookingDetails);